import { render, staticRenderFns } from "./PasswordRecoveryEmailComplete.vue?vue&type=template&id=5a10719a&lang=pug&"
import script from "./PasswordRecoveryEmailComplete.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryEmailComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports